import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Info banner shown on Catalog Operations once a trial subsidiary has at
 * least one batch that finished enrichment (i.e. reached AWAITING_APPROVAL —
 * trial batches never get a real delivery step, so that's their "completed"
 * state). Points the user at the gap analysis on individual batches and
 * reminds them delivery metrics only activate in production.
 */
export function TrialCatalogEnrichedBanner() {
  const { t } = useTranslation('catalog-operations');

  return (
    <div
      data-testid="catalog-ops-trial-enriched-banner"
      className="bg-tag-chip-bg flex items-start gap-3 rounded-xl px-5 py-4"
    >
      <Info className="text-primary mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <div>
        <p className="text-sm font-semibold">{t('trialEnrichedBanner.title')}</p>
        <p className="text-foreground mt-1 text-sm">{t('trialEnrichedBanner.description')}</p>
      </div>
    </div>
  );
}
